import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import bebe from "../assets/newImg/bebe.png";
import drainage from "../assets/newImg/drainage lumpthatique.png";
import enceinte from "../assets/newImg/femme enceinte.png";
import maxime from "../assets/newImg/maxime.png";
import maximeMobile from "../assets/newImg/maxime.png";
import sportif from "../assets/newImg/sportif.png";
import SEO from "../components/SEO";
import { SX } from "../sx";
import { C, F, R, S, maxW } from "../tokens";

const PUBLICS = [
  {
    img: bebe,
    alt: "Nourrissons",
    label: "Nourrissons",
    to: "/pathologies/nourrissons",
  },
  {
    img: enceinte,
    alt: "Femmes enceintes",
    label: "Femmes enceintes",
    to: "/pathologies/femme-enceinte",
  },
  {
    img: sportif,
    alt: "Sportifs",
    label: "Sportifs",
    to: "/pathologies/sportifs",
  },
  {
    img: drainage,
    alt: "Drainage lymphatique",
    label: "Drainage lymphatique",
    to: "/pathologies/drainage-lymphatique",
  },
];

const TIMELINE = [
  {
    year: "2019",
    title: "Diplôme d'Ostéopathie (D.O.)",
    desc: "Conservatoire Supérieur d'Ostéopathie  Toulouse",
  },
  {
    year: "2020",
    title: "Drainage lymphatique  méthode Vodder",
    desc: "Formation certifiante, approche manuelle douce",
  },
  {
    year: "2021",
    title: "Ostéopathie pédiatrique & traitement crânien",
    desc: "Approche spécifique nourrissons et jeunes enfants",
  },
  {
    year: "2022",
    title: "Ostéopathie périnatale & post-partum",
    desc: "Accompagnement grossesse et retour à l'équilibre",
  },
];

const PRINCIPES = [
  {
    num: "01",
    title: "Écouter d'abord",
    desc: "Chaque consultation commence par un temps d'échange approfondi. Vos antécédents, vos douleurs, votre quotidien  tout compte.",
  },
  {
    num: "02",
    title: "Soigner sa demande",
    desc: "Je m'adapte à ce que vous venez chercher : soulagement immédiat, prévention, suivi de grossesse ou accompagnement sportif.",
  },
  {
    num: "03",
    title: "Prendre son temps",
    desc: "Les consultations durent 45 à 60 minutes. Pas de précipitation. Le corps a besoin de temps pour intégrer le travail ostéopathique.",
  },
];

const VotreOsteopathe = () => (
  <>
    <SEO
      title="Votre Ostéopathe  Maxime Nicolaieff D.O."
      description="Découvrez le parcours de Maxime Nicolaieff, ostéopathe D.O. diplômé du CSO Toulouse en 2019. Spécialisé en ostéopathie pédiatrique, périnatale et drainage lymphatique à Balma."
      path="/votre-osteopathe"
    />
    {/* ── Hero ─────────────────────────────────────── */}
    <Box component="section" sx={{ pt: "68px", backgroundColor: C.bg }}>
      <Box
        sx={{
          maxWidth: maxW,
          mx: "auto",
          px: { xs: "1rem", md: "2.5rem" },
          pt: { xs: "3.5rem", md: "5rem" },
          pb: { xs: "2.5rem", md: "4rem" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 380px" },
          gap: { xs: "2.5rem", md: "4rem" },
          alignItems: "center",
        }}
      >
        <Box>
          <Box component="span" sx={SX.sectionLabel}>
            À propos
          </Box>
          <Typography
            variant="h1"
            component="h1"
            sx={{ ...SX.displayTitle, mt: ".5rem", mb: "1.25rem" }}
          >
            Maxime Nicolaieff, <em>ostéopathe D.O.</em>
          </Typography>
          <Typography
            sx={{
              fontFamily: F.display,
              fontSize: "1.3rem",
              fontStyle: "italic",
              color: C.textMuted,
              borderLeft: `3px solid ${C.accent}`,
              pl: "1.25rem",
              mb: "1.5rem",
              lineHeight: 1.5,
            }}
          >
            « Soigner par les mains, écouter avant tout. »
          </Typography>
          <Box
            sx={{
              fontSize: ".9rem",
              color: C.textMuted,
              lineHeight: 1.8,
              maxWidth: "480px",
              "& p + p": { mt: ".85rem" },
            }}
          >
            <Typography>
              Diplômé en 2019 du Conservatoire Supérieur d'Ostéopathie de
              Toulouse, je vous reçois dans{" "}
              <Box
                component={Link}
                to="/cabinets"
                sx={{
                  color: C.primary,
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                deux cabinets en région toulousaine
              </Box>{" "}
              : à Balma et à Castelnau-d'Estrétefonds.
            </Typography>
            <Typography sx={{ mt: ".85rem" }}>
              Ma pratique s'est enrichie d'une formation continue drainage
              lymphatique méthode Vodder,{" "}
              <Box
                component={Link}
                to="/pathologies/nourrissons"
                sx={{
                  color: C.primary,
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                ostéopathie pédiatrique
              </Box>{" "}
              et{" "}
              <Box
                component={Link}
                to="/pathologies/femme-enceinte"
                sx={{
                  color: C.primary,
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                périnatale
              </Box>{" "}
              pour accompagner chaque patient dans la globalité de sa santé.
            </Typography>
            <Typography sx={{ mt: ".85rem" }}>
              Je me déplace également à domicile sur un rayon de 20 km autour de
              Balma, pour les personnes qui ne peuvent pas se déplacer au
              cabinet.
            </Typography>
          </Box>
          <Typography
            sx={{
              mt: "1.75rem",
              fontFamily: F.display,
              fontSize: "1.25rem",
              fontStyle: "italic",
              color: C.text,
            }}
          >
            Maxime Nicolaieff
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: { xs: "auto", md: "550px" },
            borderRadius: R.lg,
            overflow: "hidden",
            boxShadow: S.lg,
          }}
        >
          <Box
            component="img"
            src={maxime}
            alt="Maxime Nicolaieff ostéopathe"
            sx={{
              display: { xs: "none", md: "block" },
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <Box
            component="img"
            src={maximeMobile}
            alt="Maxime Nicolaieff ostéopathe"
            sx={{
              display: { xs: "block", md: "none" },
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Box>
    </Box>

    {/* ── Quatre publics ───────────────────────────── */}
    <Box component="section" sx={{ py: "5.5rem", backgroundColor: C.bgAlt }}>
      <Box
        sx={{ maxWidth: maxW, mx: "auto", px: { xs: "1rem", md: "2.5rem" } }}
      >
        <Box component="span" sx={SX.sectionLabel}>
          Spécialisations
        </Box>
        <Typography
          variant="h2"
          component="h2"
          sx={{ ...SX.displayTitle, mb: "2.5rem" }}
        >
          Quatre publics, <em>quatre approches</em> distinctes.
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
            gap: "1.25rem",
          }}
        >
          {PUBLICS.map((p) => (
            <Box
              key={p.label}
              component={Link}
              to={p.to}
              sx={{
                borderRadius: R.lg,
                overflow: "hidden",
                height: "260px",
                position: "relative",
                display: "block",
                textDecoration: "none",
                cursor: "pointer",
                "&:hover img": { transform: "scale(1.04)" },
              }}
            >
              <Box
                component="img"
                src={p.img}
                alt={p.alt}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform .5s ease",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(17,29,20,.7) 0%, transparent 55%)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  padding: "1.25rem",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: F.display,
                    fontSize: "1.15rem",
                    fontWeight: 400,
                    color: "#fff",
                  }}
                >
                  {p.label}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>

    {/* ── Formation ────────────────────────────────── */}
    <Box component="section" sx={{ py: "6rem" }}>
      <Box
        sx={{
          maxWidth: maxW,
          mx: "auto",
          px: { xs: "1rem", md: "2.5rem" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: { xs: "3rem", md: "5rem" },
          alignItems: "start",
        }}
      >
        <Box>
          <Box component="span" sx={SX.sectionLabel}>
            Parcours
          </Box>
          <Typography
            variant="h2"
            component="h2"
            sx={{ ...SX.displayTitle, mb: "1.25rem" }}
          >
            Une formation continue, <em>année après année.</em>
          </Typography>
          <Typography
            sx={{ fontSize: ".9rem", color: C.textMuted, lineHeight: 1.8 }}
          >
            L'ostéopathie est une discipline vivante. Je consacre chaque année
            du temps à des formations complémentaires pour affiner ma pratique
            et proposer des approches toujours plus adaptées à mes patients.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.75rem" }}>
          {TIMELINE.map((t) => (
            <Box
              key={t.year}
              sx={{
                display: "grid",
                gridTemplateColumns: "52px 1fr",
                gap: "1rem",
                alignItems: "start",
              }}
            >
              <Box
                component="span"
                sx={{
                  fontFamily: F.display,
                  fontSize: "1.5rem",
                  fontWeight: 300,
                  color: C.accent,
                  lineHeight: 1.1,
                }}
              >
                {t.year}
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: ".88rem",
                    fontWeight: 600,
                    color: C.text,
                    mb: ".2rem",
                  }}
                >
                  {t.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ".8rem",
                    color: C.textMuted,
                    lineHeight: 1.6,
                  }}
                >
                  {t.desc}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>

    {/* ── Kiné vs Ostéo ────────────────────────────── */}
    <Box component="section" sx={{ py: { xs: "3rem", md: "5.5rem" } }}>
      <Box
        sx={{ maxWidth: maxW, mx: "auto", px: { xs: "1rem", md: "2.5rem" } }}
      >
        <Box component="span" sx={SX.sectionLabel}>
          FAQ
        </Box>
        <Typography
          variant="h2"
          component="h2"
          sx={{ ...SX.displayTitle, mb: "2.5rem" }}
        >
          Kiné ou ostéo <em>quelle différence ?</em>
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: "1.5rem",
          }}
        >
          {[
            {
              label: "Kinésithérapeute",
              color: "#e8f0fe",
              border: "#b8cff5",
              items: [
                "Rééducation après chirurgie ou fracture",
                "Renforcement musculaire progressif",
                "Rééducation respiratoire",
                "Suivi post-AVC ou neurologique",
                "Prescription médicale souvent requise",
              ],
            },
            {
              label: "Ostéopathe",
              color: "#edf5f1",
              border: "#b8d9c8",
              items: [
                "Douleurs chroniques sans lésion structurelle",
                "Troubles fonctionnels (digestion, migraines, vertiges)",
                "Prévention et suivi global",
                "Nourrissons, femmes enceintes, sportifs",
                "Accès direct sans ordonnance",
              ],
            },
          ].map((col) => (
            <Box
              key={col.label}
              sx={{
                background: col.color,
                border: `1px solid ${col.border}`,
                borderRadius: R.lg,
                padding: "1.75rem",
              }}
            >
              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: 700,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  color: C.text,
                  mb: "1.25rem",
                }}
              >
                {col.label}
              </Typography>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: ".6rem" }}
              >
                {col.items.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: ".6rem",
                      fontSize: ".83rem",
                      color: C.textMuted,
                      lineHeight: 1.5,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ color: C.accent, flexShrink: 0, fontWeight: 700 }}
                    >
                      ✓
                    </Box>
                    {item}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
        <Typography
          sx={{
            mt: "1.5rem",
            fontSize: ".82rem",
            color: C.textMuted,
            fontStyle: "italic",
            lineHeight: 1.7,
          }}
        >
          Ces deux professions sont complémentaires. Pour une hernie discale, un
          ostéopathe traite les tensions mécaniques globales pendant que le kiné
          renforce le gainage. N'hésitez pas à consulter les deux en parallèle.
        </Typography>
      </Box>
    </Box>

    {/* ── Trois principes ──────────────────────────── */}
    <Box component="section" sx={{ backgroundColor: C.dark, py: "6rem" }}>
      <Box
        sx={{ maxWidth: maxW, mx: "auto", px: { xs: "1rem", md: "2.5rem" } }}
      >
        <Box sx={{ mb: "3.5rem" }}>
          <Box component="span" sx={SX.sectionLabelWhite}>
            Ma philosophie
          </Box>
          <Typography variant="h2" component="h2" sx={SX.displayTitleWhite}>
            Trois principes qui <em>guident</em> chaque consultation.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(3, 1fr)",
            },
            gap: "2.5rem",
          }}
        >
          {PRINCIPES.map((p) => (
            <Box
              key={p.num}
              sx={{
                borderTop: "1px solid rgba(255,255,255,.12)",
                pt: "1.5rem",
              }}
            >
              <Typography
                sx={{
                  fontFamily: F.display,
                  fontSize: "2.5rem",
                  fontWeight: 300,
                  color: C.accent,
                  lineHeight: 1,
                  mb: ".75rem",
                }}
              >
                {p.num}
              </Typography>
              <Typography
                sx={{
                  fontSize: ".95rem",
                  fontWeight: 600,
                  color: "#fff",
                  mb: ".5rem",
                }}
              >
                {p.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: ".83rem",
                  color: "rgba(255,255,255,.55)",
                  lineHeight: 1.7,
                }}
              >
                {p.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </>
);

export default VotreOsteopathe;
